// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"4e204027","303":"5cddc3dd","647":"7076b11d","658":"00aa06eb","817":"a1486705"}[chunkId] + ".chunk.js";
};